import React, { useState } from "react";
import "../App.css";
import { AiOutlineUpload } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  submitContactForm,
  resetContactState,
} from "../redux/slices/contactSlice";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"; //

const ContactForm = () => {
  const [formData, setFormData] = useState({
    contactName: "",
    street: "",
    city: "",
    postcode: "",
    phone: "",
    email: "",
    idea: "",
    nda: false,
    file: null, // State to store the selected file
  });
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector(
    (state) => state.contact
  );
  const [preview, setPreview] = useState(null);
  const navigate = useNavigate(); // Initialize the navigate function

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log(e.target.files[0]);
    if (file) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        file: file,
      }));
      setPreview(URL.createObjectURL(file)); // Create a preview URL for the selected file
    }
  };
  console.log("file", formData.file);

  const formDataToObject = (formData) => {
    const obj = {};
    formData.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("contactName", formData.contactName);
    data.append("street", formData.street);
    data.append("city", formData.city);
    data.append("postcode", formData.postcode);
    data.append("phone", formData.phone);
    data.append("email", formData.email);
    data.append("idea", formData.idea);
    data.append("nda", formData.nda);

    if (formData.file) {
      data.append("file", formData.file);
    }

    dispatch(submitContactForm(data));
  };

  useEffect(() => {
    if (success) {
      Swal.fire({
        title: "Success!",
        text: "Thanks for sending your details!",
        icon: "success",
      }).then(() => {
        setFormData({
          contactName: "",
          street: "",
          city: "",
          postcode: "",
          phone: "",
          email: "",
          idea: "",
          nda: false,
          file: null,
        });
        setPreview(null);
        dispatch(resetContactState());
        navigate("/");
      });
    }

    if (error) {
      Swal.fire({
        title: "Error!",
        text: error,
        icon: "error",
      });
      dispatch(resetContactState());
    }
  }, [success, error]);


  return (
    <div className="relative">
      <div className="contact-container" id="contact">
        <div className="contact-content md:px-12">
          <h2 className="text-4xl font-bold">
            Get Started with <span>Maxify Solutions</span>
          </h2>
          <p className="text-sm text-justify">
            Are you ready to take your business to new heights? Contact Maxify
            Solutions today to find out how we can help you in achieving your
            goals. We're here to help you find a trusted website development
            company in Noida or the best digital marketing services provider in
            Noida. Let's partner to capitalize on new opportunities and drive
            your company to the next step.
          </p>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="contactName"
              placeholder="Contact name"
              value={formData.contactName}
              onChange={handleChange}
              required
              className="focus:outline-none"
            />

            <input
              type="text"
              name="street"
              placeholder="Street"
              value={formData.street}
              onChange={handleChange}
              required
              className="focus:outline-none"
            />

            <div className="form-group">
              <div className="input-half">
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  className="focus:outline-none"
                />
              </div>
              <div className="input-half">
                <input
                  type="text"
                  name="postcode"
                  placeholder="Postcode"
                  value={formData.postcode}
                  onChange={handleChange}
                  required
                  className="focus:outline-none"
                />
              </div>
            </div>

            <input
              type="text"
              name="phone"
              placeholder="Contact Phone"
              className="focus:outline-none"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="E-mail"
              value={formData.email}
              onChange={handleChange}
              required
              className="focus:outline-none"
            />

            <textarea
              name="idea"
              placeholder="Let's talk about your idea"
              value={formData.idea}
              onChange={handleChange}
              required
              className="focus:outline-none"
            ></textarea>

            {/* Other form fields */}
            <label htmlFor="file-upload" className="cursor-pointer">
              <div className="h-[100px] flex justify-center items-center gap-3 border-dashed border-[2px]">
                {preview ? (
                  <img
                    src={preview}
                    alt="Preview"
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <>
                    <AiOutlineUpload size={24} className="text-gray-600" />
                    <p
                      className="text-gray-600"
                      style={{ marginBottom: "0px" }}
                    >
                      Upload Additional File
                    </p>
                  </>
                )}
                <input
                  id="file-upload"
                  type="file"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </div>
            </label>
            <label className="checkbox-label text-sm">
              <input
                type="checkbox"
                name="nda"
                checked={formData.nda}
                onChange={handleChange}
              />
              I want to protect my data by signing an NDA
            </label>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "SUBMIT"}
            </button>
          </form>
        </div>

        <div className="map-container">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.568458764429!2d77.31315277533366!3d28.582718575691946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8cb2844875948653%3A0x31a70beb6225a223!2sMaxify%20Web%20Solutions%20pvt%20ltd!5e0!3m2!1sen!2s!4v1732103560139!5m2!1sen!2s" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
